import { render, staticRenderFns } from "./Updater.vue?vue&type=template&id=1b780dd2&scoped=true&"
import script from "./Updater.vue?vue&type=script&lang=js&"
export * from "./Updater.vue?vue&type=script&lang=js&"
import style0 from "./Updater.vue?vue&type=style&index=0&id=1b780dd2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b780dd2",
  null
  
)

export default component.exports